// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__nd-uy","slideIn":"Toast_slideIn__i776H","icon":"Toast_icon__QI9U5","slideOut":"Toast_slideOut__D70MD"};